import React from 'react';
import {Link} from 'react-router-dom';

function Header() {

  return (
	  <>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <p className="wow fadeInUp">Copyright © 2024 Jio Platforms Ltd. All rights reserved.</p>
            </div>
            <div className="col-md-6 d-flex justify-content-xxl-end justify-content-xl-end justify-content-lg-end justify-content-center">
              <a href="#!" className="wow fadeInUp">Terms & Conditions</a>
              <a href="Privacy_Policy_JCMP.pdf" target='_blank' className="wow fadeInUp">Privacy Policy</a>
              <a href="#!" className="wow fadeInUp">FAQ's</a>
              <a href="#!" className="wow fadeInUp">Feedback</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Header;
